import { styled } from "@mui/system";
import Button from "@mui/material/Button";

export const Container = styled("div")({
  backgroundColor: "rgba(0,0,0,.3)",
  "& .MuiPaper-root": {
    borderRadius: "16px"
  }
});

export const Paper = styled("div")(({ theme }) => ({
  width: "360px",
  borderRadius: "16px !important",
  "@media (max-width: 420px)": {
    overflow: "hidden"
  },
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  paddingBottom: "24px"
}));

export const DialogWrapper = styled("div")(({ theme }) => ({
  padding: "24px",
  "& .MuiDialogTitle-root": {
    padding: "0px",
    fontSize: "28px",
    lineHeight: "36px",
    fontWeight: 500,
    color: "var(--colour-text-primary, #000)",
    textAlign: "center",
    textTransform: "capitalize",
    marginBottom: "16px"
  },
  "& .MuiDialogContent-root": {
    padding: 0,
    "& div": {
      margin: 0,
      color: "var(--colour-text-primary, #000)"
    }
  },
  [theme.breakpoints.up("sm")]: {
    padding: "38px"
  }
}));

export const Title = styled("div")({
  padding: "40px 40px 20px 40px",
  "& > h2": {
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: 1.33,
    letterSpacing: "normal"
  }
});

export const Content = styled("div")({
  padding: "8px 40px"
});

export const Divider = styled("div")({
  height: "1px",
  margin: "24px 0",
  backgroundColor: "var(--colour-outline-primary, #C7C7C7)"
});

export const DialogActions = styled("div")(({ theme }) => ({
  padding: "20px",
  justifyContent: "center",
  "@media (max-width: 372px)": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  }
}));

export const ButtonSpacing = styled("div")({
  width: "100%",
  display: "flex",
  gap: "8px"
});

export const ActionButton = styled(Button)(({ theme }) => ({
  height: "40px",
  width: "100%",
  borderRadius: "21px",
  textTransform: "capitalize",
  fontSize: "16px",
  fontWeight: 600,
  letterSpacing: "normal",
  "@media (max-width: 372px)": {
    width: "100%",
    marginLeft: 0
  }
}));

export const MarginTop12 = styled("div")(({ theme }) => ({
  "@media (max-width: 372px)": {
    marginTop: "12px",
    marginLeft: 0
  }
}));
